import { Component, EventEmitter, Output, } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-modal-type-user',
  templateUrl: './modal-type-user.component.html',
  styleUrls: ['./modal-type-user.component.scss']
})
export class ModalTypeUserComponent {

  @Output() dadosEnviados = new EventEmitter<string>();

  formUser: FormGroup;

  arrayOptions = [
    { op: 'Trader' },
    { op: 'Produtor' }
  ]

  constructor(public fb: FormBuilder) {
    this.formUser = fb.group({
      userType: ['', [Validators.required]],
    });
  }

  enviarDados() {
    const dados = this.formUser.get('userType')?.value;
    this.dadosEnviados.emit(dados);
  }

  enviarDadosCancel() {
    this.dadosEnviados.emit('close');
  }
}
